import './App.css';
import Navbar from './Components/Navbar';
import { Route, Routes } from 'react-router-dom';
import { Home, About, Privacy, Resume } from './Pages';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Navbar />
      </header>

      <main className='container App-main'>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </main>

      <footer className='App-footer py-3 py-lg-4'>
        <div id="footer" className="container">
          <div id="copyright">
            <p>Copyright © 2026. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
